import api from './http';

// Email compose (Brevo)
export const searchEmailRecipients = (q = '', limit = 30) => api.get(`/email-compose/recipients?q=${encodeURIComponent(q)}&limit=${limit}`);
export const sendComposedEmail = (payload) => api.post('/email-compose/send', payload);
export const listEmailComposeLogs = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return api.get(`/email-compose/logs${qs ? `?${qs}` : ''}`);
};

// Email segments
export const listEmailSegments = () => api.get('/email-segments');
export const createEmailSegment = (data) => api.post('/email-segments', data);
export const updateEmailSegment = (id, data) => api.patch(`/email-segments/${id}`, data);
export const deleteEmailSegment = (id) => api.delete(`/email-segments/${id}`);
export const resolveEmailSegment = (id) => api.get(`/email-segments/${id}/resolve`);
export const previewEmailSegment = (filters) => api.post('/email-segments/preview', { filters });

// Email logs and sending (existing providers)
export const sendEmail = (data) => api.post('/emails/send', data);
export const getEmailLogs = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return api.get(`/emails/logs${queryString ? `?${queryString}` : ''}`);
};
export const sendTestEmail = () => api.post('/emails/test');
export const getDeliveryLogs = (params = {}) => api.get(`/emails/delivery-logs?${new URLSearchParams(params)}`);
export const syncDeliveryLogs = (ids) => api.post('/emails/delivery-logs/sync', { ids }, { timeout: 120000 });

// Domain management
export const getDomainStatus = () => api.get('/emails/domain-status');
export const addDomain = (data) => api.post('/emails/domain/add', data);
export const verifyDomain = (data) => api.post('/emails/domain/verify', data);
export const updateEmailConfig = (data) => api.patch('/emails/config', data);
